import { render, staticRenderFns } from "./xiaoxi.vue?vue&type=template&id=f03fb2dc&scoped=true"
import script from "./xiaoxi.vue?vue&type=script&lang=js"
export * from "./xiaoxi.vue?vue&type=script&lang=js"
import style0 from "./xiaoxi.vue?vue&type=style&index=0&id=f03fb2dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03fb2dc",
  null
  
)

export default component.exports